import {
  DELETEDEPARTMENT_FAIL,
  DELETEDEPARTMENT_SUCCESS,
} from "../actionTypes";

const initialState = {
  user: null,
};

const deleteDepartmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETEDEPARTMENT_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload.user,
      };
    case DELETEDEPARTMENT_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    default:
      break;
  }

  return state;
};

export default deleteDepartmentReducer;
